import axios from "axios";

export const getPublications = async (values) => {
  const { status, data } = await axios.post(
    "/api/v1/publicationManagement/getPublications",
    {
      ...values,
    }
  );
  if (status === 200 && data.success === true) {
    return data.result;
  }
  return null;
};
export const getSubscriptions = async (values) => {
  const { status, data } = await axios.post(
    "/api/v1/publicationManagement/getSubscriptions",
    {
      ...values,
    }
  );
  if (status === 200 && data.success === true) {
    return data.result;
  }
  return null;
};

export const updatePublication = async ({ id, input }) => {
  const { status, data } = await axios.post(
    "/api/v1/publicationManagement/updatePublication",
    {
      id,
      input,
    }
  );
  if (status === 200 && data.success === true) {
    return data.result;
  }

  return null;
};
